import { Expose } from 'class-transformer';

export default class SignupError {
  email: string[] = []
  password1: string[] = []
  password2: string[] = []
  @Expose({ name: '_schema' }) schema: string[] = []
}